import { useState, useEffect, useCallback, useRef } from "react";
import quotes from "../data/quotesData";

export default function useQuote() {
  const [currentQuote, setCurrentQuote] = useState(null);
  const [visible, setVisible] = useState(false);
  const lastIndex = useRef(null);
  const intervalRef = useRef(null);

  const pickQuote = useCallback(() => {
    const available = quotes.filter((_, i) => i !== lastIndex.current);
    const next = available[Math.floor(Math.random() * available.length)];
    lastIndex.current = quotes.indexOf(next);
    setCurrentQuote(next);
  }, []);

  const open = useCallback(() => {
    setVisible(true);
  }, []);

  const close = useCallback(() => {
    setVisible(false);
  }, []);

  const toggle = useCallback(() => {
    setVisible((prev) => {
      if (!prev) {
        pickQuote();
      }
      return !prev;
    });
  }, [pickQuote]);

  const nextQuote = useCallback(() => {
    pickQuote();
  }, [pickQuote]);

  useEffect(() => {
    if (!visible) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      return;
    }
    intervalRef.current = setInterval(() => {
      pickQuote();
    }, 8000);
    return () => clearInterval(intervalRef.current);
  }, [visible, pickQuote]);

  useEffect(() => {
    if (!visible) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setVisible(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [visible]);

  return { currentQuote, visible, open, close, toggle, nextQuote };
}
